export default __webpack_public_path__ + "static/media/gallery-wip-neck-base_08.814d8ce7.jpg";